import React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  &&& {
    background-color: #fff;
    height: 34px;
    margin-right: 3px;
    width: 96%;
  }
`;

const ContentInput = ({
  type = "text",
  value,
  onChange,
  placeholder,
  maxLength,
  width = "96%",
  style = {},
  disabled = false,
  readOnly = false,
  min,
  max,
}) => {
  return (
    <StyledInput
      type={type}
      width={width}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={maxLength}
      style={{ width: width, ...style }}
      disabled={disabled}
      readOnly={readOnly}
      min={min}
      max={max}
    />
  );
};

export default ContentInput;
